import {gateway} from '../utils/api'

export const getInterests = async () => {
  return gateway.get('/webbff/admin_app_web/information/track-suggestions')
}

export const getCategoriesAndSubcategories = async () => {
  return gateway.get('/webbff/lit_app_web/search/getCategoriesAndSubcategories')
}
